import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const _19mpIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"19mp"} ref={ref}/>
});

_19mpIcon.displayName = "_19mpIcon";
